import UnivoLink from "@/components/common/UnivoLink";
import styles from "./CoursePromoBanner.module.scss";

export interface SlideData {
  badge?: string;
  partner?: string;
  title?: string;
  duration?: string;
  rating?: string;
  learners?: string;
  ctaText?: string;
  ctaHref?: string;
  badgeColor?: string;
  backgroundImage?: string;
}

const SparkleIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={styles.sparkleIcon}
  >
    <path
      d="M7 1L8.5 5.5H13L9.25 8.25L10.75 12.75L7 10L3.25 12.75L4.75 8.25L1 5.5H5.5L7 1Z"
      fill="#ffffff"
    />
  </svg>
);

const ClockIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={styles.statIcon}
  >
    <circle
      cx="7"
      cy="7"
      r="5.83"
      stroke="rgba(255,255,255,0.7)"
      strokeWidth="1.17"
    />
    <path
      d="M7 4.08V7L8.75 8.75"
      stroke="rgba(255,255,255,0.7)"
      strokeWidth="1.17"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StarIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={styles.statIcon}
  >
    <path
      d="M7 1.17L8.63 4.86L12.83 5.28L9.83 8.04L10.7 12.25L7 10.08L3.3 12.25L4.17 8.04L1.17 5.28L5.37 4.86L7 1.17Z"
      fill="#F5C518"
    />
  </svg>
);

const UsersIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={styles.statIcon}
  >
    <path
      d="M11 12.83V11.5A2.83 2.83 0 0 0 8.17 8.67H3.83A2.83 2.83 0 0 0 1 11.5V12.83"
      stroke="rgba(255,255,255,0.7)"
      strokeWidth="1.17"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6"
      cy="4.5"
      r="2.83"
      stroke="rgba(255,255,255,0.7)"
      strokeWidth="1.17"
    />
    <path
      d="M15 12.83V11.5A2.83 2.83 0 0 0 12.83 8.73"
      stroke="rgba(255,255,255,0.7)"
      strokeWidth="1.17"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.83 1.4A2.83 2.83 0 0 1 10.83 7.27"
      stroke="rgba(255,255,255,0.7)"
      strokeWidth="1.17"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={styles.arrowIcon}
  >
    <path
      d="M3.33 8H12.67M8.67 4L12.67 8L8.67 12"
      stroke="#1b294b"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function SlideContent({ slide }: { slide: SlideData }) {
  return (
    <div
      className={styles.content}
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(3, 7, 17, 0.9) 0%, rgba(3, 7, 17, 0.6) 50%, rgba(3, 7, 17, 0) 100%), url('${slide.backgroundImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className={styles.left}>
        <div className={styles.topRow}>
          <span
            className={styles.badge}
            style={{ backgroundColor: slide.badgeColor }}
          >
            <SparkleIcon />
            {slide.badge}
          </span>
          <span className={styles.partner}>{slide.partner}</span>
        </div>

        <h2 className={styles.title}>{slide.title}</h2>

        <div className={styles.statsRow}>
          <span className={styles.stat}>
            <ClockIcon />
            {slide.duration}
          </span>
          <span className={styles.statDivider} aria-hidden="true" />
          <span className={styles.stat}>
            <StarIcon />
            {slide.rating}
          </span>
          <span className={styles.statDivider} aria-hidden="true" />
          <span className={styles.stat}>
            <UsersIcon />
            {slide.learners}
          </span>
        </div>
      </div>

      <div className={styles.right}>
        <UnivoLink
          prefetch={false}
          href={slide.ctaHref ?? "#"}
          className={styles.ctaButton}
        >
          {slide.ctaText}
          <ArrowIcon />
        </UnivoLink>
      </div>
    </div>
  );
}
